import { ChildAccount } from '../../../profile-base/interfaces/child-account/child-account';

export class ProfileBaseState {
    additionalProfiles: ChildAccount[] = [];
    selectedAdditionalProfileId: number | null = null;
}